import { render, staticRenderFns } from "./WorkoutList.vue?vue&type=template&id=5768ed0e&scoped=true&"
import script from "./WorkoutList.vue?vue&type=script&lang=js&"
export * from "./WorkoutList.vue?vue&type=script&lang=js&"
import style0 from "./WorkoutList.vue?vue&type=style&index=0&id=5768ed0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5768ed0e",
  null
  
)

export default component.exports